import type { ReactNode } from 'react';
import Image from 'next/image';
import { Popup } from '@/components';
import type { IPopup } from '@/components/Popup/Popup';
import {
  DialogWrapper,
  DialogSubText,
  DialogMainText,
  DialogContentWrapper,
  DialogHeaderWrapper,
  DialogHeaderContentWrapper,
  DialogExit,
  CloseIcon,
} from './Dialog.styles';

type TDialogHeaderProps = {
  children?: ReactNode;
  closeable?: boolean;
  onClose?: () => void;
};

const DialogHeader = ({ children, closeable = false, onClose }: TDialogHeaderProps) => {
  return (
    <DialogHeaderWrapper>
      <Image src='/images/verify-graphic.svg' alt='Dialog header graphic' fill sizes='100vw' />
      {closeable && (
        <DialogExit onClick={onClose}>
          <CloseIcon />
        </DialogExit>
      )}
      <DialogHeaderContentWrapper>{children}</DialogHeaderContentWrapper>
    </DialogHeaderWrapper>
  );
};

const DialogContent = ({ children }: { children: ReactNode }) => {
  return <DialogContentWrapper>{children}</DialogContentWrapper>;
};

interface IDialog extends IPopup {
  children: ReactNode;
}

const Dialog = ({ show, onHide, children }: IDialog) => {
  return (
    <Popup show={show} onHide={onHide}>
      <DialogWrapper>{children}</DialogWrapper>
    </Popup>
  );
};

Dialog.Header = DialogHeader;
Dialog.Content = DialogContent;
Dialog.MainText = DialogMainText;
Dialog.SubText = DialogSubText;

export { Dialog };
